export class SMSLogPresenterModel {
  id: string;
  /**
   * The recipients of the SMS.
   */
  to: string | string[];
  /**
   * The body of the SMS.
   */
  body: string;
  /**
   * The message id from the service bus.
   */
  messageId?: string;
  /**
   * The timestamp when the SMS was generated by the system.
   */
  generatedAt: string;
  /**
   * The timestamp when the SMS was sent.
   */
  timestamp: string;
  /**
   * Whether the SMS was sent successfully or not.
   */
  status: string;
  /**
   * The strategy used for sending the SMS.
   */
  strategy: string;
  /**
   * The error message generated in case an exception is thrown
   */
  errorMessage?: string;
  /**
   * The response returned frm the SMS provider.
   */
  smsProviderResponse?: any;
  /**
   * The related trigger execution id if the SMS was sent as a result of a trigger.
   */
  relatedTriggerExecutionId: string | null;
}
